import { AxiosError } from 'axios';
import { AppDispatch } from '../../../store';
import {
    ErrorResponse,
    globalError,
    globalErrorResponse,
    showNotificationWithInfo
} from '../../../store/notifications/actions';
import { push } from 'connected-react-router';
import i18n from '../../../../i18n';

const isAxiosError = (error: any): error is AxiosError => {
    return error.hasOwnProperty('response');
};

export function typedFailure(error: ErrorResponse, route: string) {
    return (dispatch: AppDispatch) => {
        if (!isAxiosError(error)) {
            return dispatch(globalErrorResponse(error));
        }
        switch (error.response?.status) {
            case 403:
                if (error.response.data.errorCode === 'outdatedShoppingCartVersion') {
                    dispatch(
                        showNotificationWithInfo(
                            null,
                            error.response.data.message,
                            null,
                            null,
                            () => window.location.reload(),
                            true,
                            'Reload'
                        )
                    );
                } else if (error.response.data.errorCode === 'invalidProductFormatForCustomer') {
                    dispatch(
                        showNotificationWithInfo(null, error.response.data.message, null, null, () =>
                            dispatch(push(route))
                        )
                    );
                } else if (
                    error.response.data.errorCode === 'invalidProductFormatForAccount' ||
                    error.response.data.errorCode === 'orderContainsEmagazineAlongWithOtherLoanFormat'
                ) {
                    dispatch(showNotificationWithInfo(null, error.response.data.message));
                } else {
                    dispatch(globalError(error));
                }
                break;

            case 409:
                if (error.response.data.errorCode === 'withdrawnProducts') {
                    dispatch(
                        showNotificationWithInfo(
                            i18n.t('notifications.unavailableProducts.title'),
                            i18n.t('notifications.unavailableProducts.message'),
                            null,
                            null,
                            () => dispatch(push(route))
                        )
                    );
                } else {
                    dispatch(globalErrorResponse(error));
                    dispatch(push(route));
                }
                break;

            default:
                dispatch(globalErrorResponse(error));
        }
    };
}
